'use client';

import { AuthPage } from '@/components/auth/auth-page';
import { FullScreenLoader } from '@/components/loaders';
import { useConvexAuth } from 'convex/react';
import { useRouter, useSearchParams } from 'next/navigation';
import { useEffect } from 'react';

type AuthRouteViewProps = {
  authBasePath: string;
  defaultMode: 'signIn' | 'signUp';
  signInPath?: string;
  signUpPath?: string;
};

export function AuthRouteView({
  authBasePath,
  defaultMode,
  signInPath,
  signUpPath,
}: AuthRouteViewProps) {
  const { isAuthenticated } = useConvexAuth();
  if (isAuthenticated) return <AuthenticatedRedirect />;

  return (
    <AuthPage
      authBasePath={authBasePath}
      defaultMode={defaultMode}
      signInPath={signInPath}
      signUpPath={signUpPath}
    />
  );
}

function AuthenticatedRedirect() {
  const router = useRouter();
  const searchParams = useSearchParams();

  useEffect(() => {
    const query = searchParams.toString();
    router.push(query ? `/auth/signing-in?${query}` : '/auth/signing-in');
  }, [router, searchParams]);

  return <FullScreenLoader message="Moving you along" />;
}
